const header = document.querySelector('.header');
const breakpointLg = window.matchMedia('(min-width: 1024px)');

const fixedEls = document.querySelectorAll('.must-fixed');

const isHeaderFixed = () => {
  if (header) {
    return header.classList.contains('header--fixed');
  }
};

// const addHeaderFix = () => {
//   if (breakpointLg.matches && !isHeaderFixed()) {
//     header.classList.add('header--fixed');
//   }
// };

// const removeHeaderFix = () => {
//   if (isHeaderFixed()) {
//     header.classList.remove('header--fixed');
//   }
// };

const observeFixed = () => {
  let body = document.body;
  let observer = new MutationObserver(() => {
    if (breakpointLg.matches) {
      if (fixedEls.length) {
        fixedEls.forEach((el) => {
          el.style.paddingRight = body.style.paddingRight;
        });
      }
    }
  });
  observer.observe(body, {attributes: true});
};

export {observeFixed};
